import React from "react";

export const DotSeparator = ({ customDotColor = "#596e79" }) => {
  return (
    <span style={{ display: "flex", margin: "0 2px", alignItems: "center" }}>
      <svg width="4px" height="12px" xmlns="http://www.w3.org/2000/svg">
        <circle cx="2" cy="6" r="1" fill={customDotColor} />
      </svg>
    </span>
  );
};
